
import React, { useState } from 'react'
import Typography from '@mui/material/Typography'
import GSSVG from 'smartstream-widgets/controls/GSSVG'
import { withStyles, createStyles } from '@mui/styles'
import {Grid} from '@mui/material'
import { compose } from 'widgets-shared/core'
import { withComponentContext } from 'widgets-shared/core'

type Props = {
  children: Array<React.ReactNode>,
  classes: {
    [K in string]: string
  },
  config: {
    BASE_ASSET_PATH: string,
    ShowMoreInitialNumber: number
  },
  showMoreText: string,
  showLessText: string
}

const styles = () => createStyles({
  button: {
    cursor: 'pointer'
  },
  buttonIcon: {
    marginLeft: 8
  },
  buttonText: {
    fontWeight: 'bold'
  }
})

function ShowMore (props: Props) {
  const {
    children,
    classes,
    config: {
      BASE_ASSET_PATH,
      ShowMoreInitialNumber = 3,
    },
    showMoreText,
    showLessText
  } = props

  const [isExpanded, setIsExpanded] = useState(false)
  const shouldDisplayButton = children.length > ShowMoreInitialNumber

  const onClick = () => setIsExpanded(!isExpanded)

  return (
    <>
      {isExpanded ? children : children.slice(0,ShowMoreInitialNumber)}
      {
        shouldDisplayButton &&
        <Grid
          className={classes.button}
          container
          justifyContent={'center'}
          onClick={onClick}
        >
          <Typography className={classes.buttonText}>
            {isExpanded ? showLessText : showMoreText}
          </Typography>
          <GSSVG
            className={classes.buttonIcon}
            xlinkHref={`${BASE_ASSET_PATH}/img/icons.svg#${isExpanded ? 'minus' : 'plus'}-circle`}
          />
        </Grid>
      }
    </>
  )
}

export default compose(
  withComponentContext,
  withStyles(styles)
)(ShowMore)
